const LOADPARTNERS = 'twineApp/partners/LOADPARTNERS';
const LOADPARTNERS_SUCCESS = 'twineApp/partners/LOADPARTNERS_SUCCESS';
const LOADPARTNERS_FAIL = 'twineApp/partners/LOADPARTNERS_FAIL';

const initialState = {
  partners: [],
  loadingPartners: false,
  loadedPartners: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOADPARTNERS:
      return {
        ...state,
        loadingPartners: true,
        loadedPartners: false,
        partners: [],
      };

    case LOADPARTNERS_SUCCESS:
      return {
        ...state,
        loadingPartners: false,
        loadedPartners: true,
        partners: action.result.partners
          ? action.result.partners.flatMap((partner) =>
              Array(partner.total_entries).fill(partner)
            )
          : [],
      };

    case LOADPARTNERS_FAIL:
      return {
        ...state,
        loadingPartners: false,
        loadedPartners: true,
        errors: action.error.errors,
      };
    default:
      return state;
  }
}

/**
 * Load partner adverts for a surface.
 * Logged-in users include user_id so CDN cache keys are per-user.
 * Guests omit user_id and share one guest cache entry.
 *
 * @param {string} type
 * @param {boolean} [testing=false]
 * @returns {Function}
 */
export function loadPartners(type, testing = false) {
  return (dispatch, getState) => {
    let query = `?type=${type}`;

    if (testing) query += `&testing=1`;

    const user = getState().auth && getState().auth.user;
    if (user && user.id) {
      query += `&user_id=${user.id}`;
    }

    return dispatch({
      types: [LOADPARTNERS, LOADPARTNERS_SUCCESS, LOADPARTNERS_FAIL],
      promise: (client) => client.get(`/partners${query}`),
    });
  };
}
